import useUser from '@/hooks/useUser';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';

import { PublicNarrativeCreate } from '@/pages/Narrative/components/PublicNarrativeCreate';
import { NarrativeLayout } from './NarrativeLayout';
import { NARRATIVE_USER_POSITION } from '@/pages/Narrative/utils/schema';
import GuestRegistrationModal from '@/components/GuestRegistrationModal';
import { useMount } from '@simplywallst/ui-core';
import { NarrativePanelRegister } from '@/components/GuestRegistrationModal/components/NarrativePanelRegister';
import { NarrativeNotFound } from './components/NarrativeNotFound';
import { useNarrativeCompany } from './hooks/useNarrativeCompany';

export const PublicNarrativeCreatePage = () => {
  const { getItem } = useQueryStringParam();

  const { data: user, queryStatus: userStatus } = useUser();

  const companyId = getItem('company');
  const initialUserHoldsPosition =
    getItem('position') === NARRATIVE_USER_POSITION.HOLDS;

  const { data: companyResponse, status: companyStatus } = useNarrativeCompany(
    {
      companyId: companyId!,
    },
    {
      enabled: Boolean(companyId && user.loggedIn),
    }
  );

  const company = companyResponse?.Company;

  if (!companyId) {
    console.warn('"company" query param was not provided.');
  }

  useMount(() => window.scrollTo(0, 0));

  if (!user.loggedIn)
    return (
      <>
        <NarrativeLayout title="Create Narrative" isLoading error={false}>
          <div />
        </NarrativeLayout>
        <GuestRegistrationModal
          SplashPanel={{
            Component: NarrativePanelRegister,
            isDark: true,
          }}
        />
      </>
    );

  if (!companyId) {
    return <NarrativeNotFound />;
  }

  const getError = () => {
    return (
      userStatus === 'error' ||
      companyStatus === 'error' ||
      typeof company === 'undefined'
    );
  };

  return (
    <NarrativeLayout
      title="Create Narrative"
      isLoading={userStatus === 'pending' || companyStatus === 'pending'}
      error={getError()}
    >
      {company && (
        <PublicNarrativeCreate
          company={company}
          initialUserHoldsPosition={initialUserHoldsPosition}
        />
      )}
    </NarrativeLayout>
  );
};
